import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import logo from './images/HRC_Logo.png';

function Navbar() {
    const [open, setOpen] = useState(false);
    const [mobileMenu, setMobileMenu] = useState(false);
    const [industry, setIndustry] = useState(false);
    const [partnership, setPartnership] = useState(false);

    // Close mobile menu on window resize
    useEffect(() => {
        const handleResize = () => setMobileMenu(false);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <>
            <nav className="w-full z-50 fixed bg-gradient-to-b from-black/90 via-black/70 to-transparent backdrop-blur-sm">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="flex justify-between h-16">
                        {/* Logo */}
                        <div className="flex-shrink-0 flex items-center">
                            <Link to="/" className="flex items-center gap-2 hover:opacity-80 transition-opacity">
                                <img src={logo} alt="HRCPRO" className="h-12 w-32" />
                                {/* <span className="text-2xl font-bold text-white hidden sm:inline">HRCPRO</span> */}
                            </Link>
                        </div>

                        {/* Desktop Menu */}
                        <div className="hidden lg:flex items-center space-x-8">
                            <Link to="/" className="text-white hover:text-blue-400 px-3 py-2 text-lg font-medium relative group">
                                Home
                                <span className="absolute left-0 -bottom-1 h-0.5 w-0 bg-blue-400 transition-all duration-300 group-hover:w-full"></span>
                            </Link>
                            
                            <Link to="/all-categories" className="text-white hover:text-blue-400 px-3 py-2 text-lg font-medium relative group">
                                Products
                                <span className="absolute left-0 -bottom-1 h-0.5 w-0 bg-blue-400 transition-all duration-300 group-hover:w-full"></span>
                            </Link>
                            
                            <Link to="/industries" className="text-white hover:text-blue-400 px-3 py-2 text-lg font-medium relative group">
                                Industries
                                <span className="absolute left-0 -bottom-1 h-0.5 w-0 bg-blue-400 transition-all duration-300 group-hover:w-full"></span>
                            </Link>

                            {/* Industries Dropdown */}
                            {/* <div className="relative group">
                                <button 
                                    onMouseOver={() => setIndustry(true)}
                                    onMouseOut={() => setIndustry(false)}
                                    className="text-white hover:text-blue-400 px-3 py-2 text-lg font-medium inline-flex items-center gap-1 relative group"
                                >
                                    Industries
                                    <svg className="w-4 h-4 transition-transform group-hover:rotate-180" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                                    </svg>
                                    <span className="absolute left-0 -bottom-1 h-0.5 w-0 bg-blue-400 transition-all duration-300 group-hover:w-full"></span>
                                </button>
                                
                                {industry && (
                                    <div 
                                        onMouseEnter={() => setIndustry(true)}
                                        onMouseLeave={() => setIndustry(false)}
                                        className="absolute left-0 mt-2 w-56 rounded-xl bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none transform opacity-100 scale-100 origin-top-right transition-all duration-200"
                                    >
                                        <div className="py-2">
                                            {['Hotels', 'Restaurants', 'Resorts', 'Banquet Halls', 'Cafes/Bars'].map((item) => (
                                                <a
                                                    key={item}
                                                    href="#"
                                                    className="block px-4 py-3 text-lg text-gray-700 hover:bg-blue-50 hover:text-blue-600 transition-colors duration-150"
                                                >
                                                    {item}
                                                </a>
                                            ))}
                                        </div>
                                    </div>
                                )}
                            </div> */}

                            {/* Partners Dropdown */}
                            {/* <div className="relative group"
                                onMouseEnter={() => setPartnership(true)}
                                onMouseLeave={() => setPartnership(false)}
                            >
                                <button
                                    className="text-white hover:text-blue-400 px-3 py-2 text-lg font-medium inline-flex items-center gap-1 relative group"
                                >
                                    Our Partners
                                    <svg className="w-4 h-4 transition-transform group-hover:rotate-180" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                                    </svg>
                                    <span className="absolute left-0 -bottom-1 h-0.5 w-0 bg-blue-400 transition-all duration-300 group-hover:w-full"></span>
                                </button>
                                {partnership && (
                                    <div
                                        className="absolute left-0 mt-0 w-56 rounded-xl bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
                                    >
                                        <div className="py-2">
                                            <a href="#" className="block px-4 py-3 text-lg text-gray-700 hover:bg-blue-50 hover:text-blue-600">Partner 1</a>
                                            <a href="#" className="block px-4 py-3 text-lg text-gray-700 hover:bg-blue-50 hover:text-blue-600">Partner 2</a>
                                        </div>
                                    </div>
                                )}
                            </div> */}

                            {/* <Link to="/resources" className="text-white hover:text-blue-400 px-3 py-2 text-lg font-medium relative group">
                                Resources
                                <span className="absolute left-0 -bottom-1 h-0.5 w-0 bg-blue-400 transition-all duration-300 group-hover:w-full"></span>
                            </Link> */}
                        </div>

                        {/* Mobile menu button */}
                        <div className="flex items-center lg:hidden">
                            <button
                                onClick={() => setMobileMenu(!mobileMenu)}
                                className="inline-flex items-center justify-center p-2 rounded-md text-white hover:text-blue-400 focus:outline-none"
                            >
                                <svg
                                    className={`${mobileMenu ? 'hidden' : 'block'} h-6 w-6`}
                                    stroke="currentColor"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M4 6h16M4 12h16M4 18h16"
                                    />
                                </svg>
                                <svg
                                    className={`${mobileMenu ? 'block' : 'hidden'} h-6 w-6`}
                                    stroke="currentColor"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M6 18L18 6M6 6l12 12"
                                    />
                                </svg>
                            </button>
                        </div>

                        {/* Quick links */}
                        <div className="hidden lg:flex items-center">
                            <button
                                onMouseOver={() => setOpen(true)}
                                onMouseOut={() => setOpen(false)}
                                className="text-white hover:text-blue-400 px-3 py-2 text-sm font-medium"
                            >
                                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z" />
                                </svg>
                            </button>
                            {open && (
                                <div
                                    onMouseOver={() => setOpen(true)}
                                    onMouseOut={() => setOpen(false)}
                                    className="absolute right-50 top-12 w-48 rounded-xl bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
                                >
                                    <div className="py-2">
                                        <Link to="/aboutus" className="block px-4 py-3 text-lg text-gray-700 hover:bg-blue-50 hover:text-blue-600">
                                            About Us
                                        </Link>
                                        <Link to="/contactus" className="block px-4 py-3 text-lg text-gray-700 hover:bg-blue-50 hover:text-blue-600">
                                            Contact Us
                                        </Link>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                {/* Mobile menu */}
                <div className={`${mobileMenu ? 'block' : 'hidden'} lg:hidden bg-black/95 backdrop-blur-sm`}>
                    <div className="px-2 pt-2 pb-3 space-y-1">
                        <Link to="/" className="block px-3 py-2 text-base font-medium text-white hover:text-blue-400">
                            Home
                        </Link>
                        <Link to="/all-categories" className="block px-3 py-2 text-base font-medium text-white hover:text-blue-400">
                            Products
                        </Link>
                        <Link to="/industries" className="block px-3 py-2 text-base font-medium text-white hover:text-blue-400">
                            Industries
                        </Link>
                        {/* <Link to="/resources" className="block px-3 py-2 text-base font-medium text-white hover:text-blue-400">
                            Resources
                        </Link> */}
                        <div className="border-t border-gray-700 pt-4">
                            <Link to="/aboutus" className="block px-3 py-2 text-base font-medium text-white hover:text-blue-400">
                                About Us
                            </Link>
                            <Link to="/contactus" className="block px-3 py-2 text-base font-medium text-white hover:text-blue-400">
                                Contact Us
                            </Link>
                        </div>
                    </div>
                </div>
            </nav>
        </>
    );
}

export default Navbar;
